import { IProfileUser } from 'shared/types/user'
import { relativeUrl } from 'shared/util/url'
import { parse } from 'url'

const getDisplayName = ({
    username,
    display_name: displayName,
    short_display_name: shortDisplayName,
}: {
    username: string
    display_name?: string
    short_display_name?: string
}) => shortDisplayName || displayName || username

// get user props for the PublicUser module
export const getAttributionProps = ({ user, source_post_url }: { user: IProfileUser; source_post_url: string }) => {
    const sourceBits = source_post_url ? parse(source_post_url) : { hostname: null }
    const source = sourceBits?.hostname?.replace('www.', '') ?? ''
    return {
        user,
        source,
        sourceFull: source_post_url,
        avatar: user ? user.avatar_url : '',
        channel: user && user.profile_url ? relativeUrl(user.profile_url) : '',
        userName: user ? getDisplayName(user) : '',
        changeIndicator: user || source,
    }
}
